import axios from 'axios';
import { toast } from 'sonner';
import { fbInitiateCheckout } from './metaPixel';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Parses cart item id like 'korean-scalp-revival-bar-b2' -> 'b2'
export const extractBundleId = (cartItemId) => {
  if (!cartItemId) return null;
  const m = String(cartItemId).match(/-(b[123])$/);
  return m ? m[1] : null;
};

export const startStripeCheckout = async ({ bundle_id, quantity = 1, currency, customer_email, coupon_code, value }) => {
  if (!bundle_id) {
    toast.error('Please pick a bundle first.');
    return;
  }
  try {
    const origin_url = window.location.origin;
    const cur = currency || localStorage.getItem('k_currency') || 'USD';
    const country = localStorage.getItem('k_country') || undefined;
    // Fire Meta Pixel InitiateCheckout BEFORE we redirect away
    fbInitiateCheckout({
      id: bundle_id,
      value,
      currency: cur,
      quantity,
      coupon: coupon_code,
    });
    const { data } = await axios.post(`${API}/checkout/session`, {
      bundle_id,
      quantity,
      origin_url,
      currency: cur,
      country,
      customer_email,
      coupon_code,
    });
    if (data?.url) {
      window.location.href = data.url;
    } else {
      toast.error('Could not start checkout.');
    }
  } catch (err) {
    const msg = err?.response?.data?.detail || 'Checkout failed. Please try again.';
    toast.error(msg);
  }
};
